import { render, staticRenderFns } from "./AccessControlSystem.vue?vue&type=template&id=ec9abe46&scoped=true"
import script from "./AccessControlSystem.vue?vue&type=script&lang=js"
export * from "./AccessControlSystem.vue?vue&type=script&lang=js"
import style0 from "./AccessControlSystem.vue?vue&type=style&index=0&id=ec9abe46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec9abe46",
  null
  
)

export default component.exports